module.exports = __webpack_public_path__ + "assets/icons/ic_done_all-9a41.svg";